<script setup lang="ts">
import { mdiAlert } from '@quasar/extras/mdi-v7';

const emit = defineEmits<{
  ok: [];
}>();
</script>

<template>
  <q-banner class="bg-negative text-white">
    <template #avatar>
      <q-icon
        :name="mdiAlert"
        size="md"
      />
    </template>
    <slot></slot>
    <template #action>
      <q-btn
        flat
        color="white"
        label="OK"
        @click="emit('ok')"
      />
    </template>
  </q-banner>
</template>
